<template>
  <div
    class="zoomer"
    :class="{ zooming: data.zooming }"
    v-on:touchstart.prevent="zoomEnter"
    v-on:touchmove.prevent="zoomMove"
    v-on:touchend.prevent="zoomExit"
    v-on:mouseenter="zoomEnter"
    v-on:mouseleave="zoomExit"
    v-on:mousemove="zoomMove"
  >
    <img ref="image" :src="props.image" :alt="props.alt" @load="loaded" />
    <div
      v-if="data.img"
      ref="zoom"
      class="img zoom"
      :style="{
        'background-position': `${data.x}% ${data.y}%`,
        'background-image': `url('${data.img}')`,
        // width: `${width}px`,
        // height: `${height}px`,
      }"
    />
    <!-- <div>{{ x }}, {{ y }}</div> -->
    <!-- <div>{{ zoomed }}</div> -->
  </div>
</template>

<script lang="ts" setup>
import { onMounted, reactive, ref, watch } from "vue";

const props = withDefaults(
  defineProps<{
    image: string;
    zoomedImage: string;
    alt: string;
    scale?: number;
  }>(),
  { scale: 4 },
);

const image = ref<HTMLImageElement>();
const data = reactive({
  zooming: false,
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  img: "",
  box: undefined as undefined | DOMRect,
  event: undefined as undefined | MouseEvent | TouchEvent,
  frame: -1,
});

watch(
  () => props.zoomedImage,
  () => {
    thumbnailImage();
  },
);

onMounted(() => {
  thumbnailImage();
});

async function thumbnailImage() {
  data.img = "";
  if (image.value) {
    const zoomer = await new Promise<HTMLImageElement>((resolve) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => resolve(img);
      img.src = props.zoomedImage;
    });
    const w = zoomer.width;
    const h = zoomer.height;

    const canvas = document.createElement("canvas");
    data.box = image.value.getBoundingClientRect();
    canvas.width = data.box.width * props.scale;
    canvas.height = data.box.height * props.scale;
    const ctx = canvas.getContext("2d");
    if (ctx) {
      ctx.drawImage(zoomer, 0, 0, w, h, 0, 0, canvas.width, canvas.height);
      data.img = canvas.toDataURL("png");
    }
  }
}

function loaded(e: any) {
  data.width = e.target.width;
  data.height = e.target.height;
}
function zoomExit() {
  data.zooming = false;
}
function zoomEnter() {
  data.zooming = true;
}
function zoomMove(ev: MouseEvent | TouchEvent) {
  data.event = ev;
  if (data.frame === -1) {
    data.frame = window.requestAnimationFrame(frameMove);
  }
}
function frameMove() {
  if ((data.event as TouchEvent).touches) {
    const te = data.event as TouchEvent;
    let x = 0;
    let y = 0;
    Array.prototype.forEach.call(te.touches, (touch) => {
      x += touch.clientX;
      y += touch.clientY;
    });
    doMove(x, y);
  } else {
    const me = data.event as MouseEvent;
    doMove(me.clientX, me.clientY);
  }
  data.frame = -1;
}
function doMove(x: number, y: number) {
  if (data.box && image.value) {
    data.x = (x - data.box.left) / (data.box.width / 100);
    data.y = (y - data.box.top) / (data.box.height / 100);
  }
}
</script>

<style scoped>
.zoomer {
  position: relative;
  border: 0;
  overflow: hidden;
  max-width: 100%;
  max-height: 100%;
  cursor: move;
  display: flex;
  justify-content: center;
  align-items: center;
}
img {
  max-width: 100%;
  max-height: 100%;
}
.img {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background-position: center center;
  background-repeat: no-repeat;
  background-color: white;
}

.zoom {
  z-index: 10;
  transition: opacity 100ms;
  opacity: 0;
}

.zooming .zoom {
  opacity: 1;
}
</style>
